var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12","align":_vm.align}},[_c('v-btn',{staticClass:"normal-btn",attrs:{"text":"","color":_vm.color},on:{"click":_vm.goTo}},[_vm._v(" "+_vm._s(_vm.name)+" "),_c('v-icon',{attrs:{"right":""}},[_vm._v("$right_arrow")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }